import React from 'react'

import { AppSvg, FormattedHTMLMessage, LinkButton, Loader, newIcons } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import styles from './style.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import ExternalLink from '~components/ExternalLink'

function Preloader() {
    const intl = useIntl()

    return (
        <ModalView
            img={
                <div className={styles.icon}>
                    <AppSvg svgName={newIcons.ic80UserPlus} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="invite_friends_content"
            className={styles.modalView}
        >
            <ExternalLink className={styles.learnMoreLink} href={intl.formatMessage(lang.learnMoreLink)}>
                <LinkButton dataPointer="balance_details_pro_link">
                    <FormattedHTMLMessage {...lang.learnMore} />
                    <div className={styles.icon}>
                        <AppSvg svgName={newIcons.ic20External} path="new-icons" size={20} />
                    </div>
                </LinkButton>
            </ExternalLink>

            <div className={styles.wrap}>
                <div className={styles.loaderWrap}>
                    <div className={styles.column}>
                        <Loader width={64} height={18} />
                        <Loader width={74} height={18} />
                        <Loader width={100} height={18} />
                    </div>
                    <div className={styles.column}>
                        <Loader width={76} height={18} />
                        <Loader width={105} height={18} />
                        <Loader width={84} height={18} />
                    </div>
                </div>

                <div className={styles.loaderInfo}>
                    <Loader borderRadius="l" width="100%" height="100%" />
                </div>
            </div>
        </ModalView>
    )
}

export default Preloader
